import { getObjectKeysAsObject } from "@checkout/helpers";
import { fetchTripInsuranceProductsService } from "./fetchRbcInsuranceProducts";

export const TripInsuranceServices = {
  fetchTripInsuranceProductsService,
};

export const TripInsuranceServiceTypes = getObjectKeysAsObject(
  TripInsuranceServices
);
